// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2jR6U","info":"PatientInfo_info__jaWc5"};